module.exports = __webpack_public_path__ + "img/XL_POINTAGES.db8775f0.svg";